import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';
import _ from 'lodash';

import * as channelController from '../../../../services/api/channel';
import * as programmeController from '../../../../services/api/programme';
import FilterGroup from '../../../../components/FilterGroup/FilterGroup';
import LeadList from './components/LeadList/LeadList';
import LeadExportModal from './components/LeadExportModal/LeadExportModal';
import { leadTypeOptions, leadSourceOptions, leadStatusOptions } from '../../../../utils/options';

export class LeadPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filters: {},
            searchText: '',
            exportModalVisible: false,
            channels: [],
            programmes: [],
        }
    }

    fetchChannels() {
        channelController.getChannels({ isSimple: true })
            .then((res) => res.json())
            .then((json) => this.setState({ channels: json}))
    }

    fetchProgrammes() {
        programmeController.getProgrammes({ isSimple: true })
            .then((res) => res.json())
            .then((json) => this.setState({ programmes: json}))
    }

    componentDidMount() {
        this.fetchChannels();
        this.fetchProgrammes();
    }

    render() {
        const { isAdmin } = this.props;
        const { filters, searchText, exportModalVisible, channels, programmes } = this.state;
        const filterList = [{
            type: 'select',
            name: 'type',
            placeholder: 'Type',
            options: _.map(leadTypeOptions, (type) => ({ label: type, value: type }))
        }, {
            type: 'select',
            name: 'source',
            placeholder: 'Source',
            options: _.map(leadSourceOptions, (source) => ({ label: source, value: source }))
        }, {
            type: 'select',
            name: 'status',
            placeholder: 'Status',
            options: _.map(leadStatusOptions, (status) => ({ label: status, value: status }))
        }, {
            type: 'select',
            name: 'interested_programme_id',
            placeholder: 'Programme',
            options: _.map(programmes, (programme) => ({ label: `[${programme.course_code ? programme.course_code.name : 'N/A'}] ${programme.programme_code} - ${programme.name}`, value: programme.id }))
        }, {
            type: 'select',
            name: 'channel_id',
            placeholder: 'Channel',
            options: _.map(channels, (channel) => ({ label: `[${channel.type ? channel.type.name : ''}]${channel.name} - ${channel.source ? channel.source.name : ''}`, value: channel.id }))
        }, {
            type: 'dateRange',
            name: 'enquiry_date',
            placeholder: ['Enquriy Date (From)', 'Enquriy Date (To)']
        }, {
            type: 'dateRange',
            name: 'next_follow_up_date',
            placeholder: ['Next Follow Up (From)', 'Next Follow Up (To)']
        }];

        return (
            <div className="LeadPage ListPage">
                <div className="page-header">
                    <h2>
                        Lead
                        {
                            isAdmin &&
                            <div className="header-btn-gp">
                                <Button 
                                    type="primary" 
                                    onClick={(e) => this.setState({ exportModalVisible: true })}
                                >
                                    Export Lead
                                </Button>
                            </div>
                        }
                    </h2>
                    <FilterGroup
                        filterList={filterList}
                        onChange={(filters, searchText) => this.setState({ filters, searchText })}
                    />
                </div>
                <LeadList
                    filters={filters}
                    searchText={searchText}
                />
                <LeadExportModal
                    visible={exportModalVisible}
                    onCancel={() => this.setState({ exportModalVisible: false })}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    isAdmin: state.user.isAdmin
})

export default connect(mapStateToProps)(LeadPage);


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/LeadPage/LeadPage.js